import { Link, NavLink } from 'react-router-dom';
import '../Navbar.css';

export default function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo">BL</Link>
      <ul className="nav-links">
        <li><NavLink to="/about">About</NavLink></li>
        <li><NavLink to="/projects">Projects</NavLink></li>
        <li><NavLink to="/experience">Experience</NavLink></li>
        <li><NavLink to="/connect">Connect</NavLink></li>
      </ul>
    </nav>
  );
}
